<template>
  <div class="bg-white p-2">
    <div>Cuộc gọi thoại</div>
    <div>{{ responseTime(duration) }} giây</div>
  </div>
</template>

<script>
export default {
  name: "ChatCall",
  props: ["duration"],
  methods:{
    responseTime(rpt) {
      let type = " giây";
      if (rpt >= 60 && rpt > 0) {
        rpt = rpt / 60;
        type = " phút";
        if (rpt >= 60) {
          rpt = rpt / 60;
          type = " giờ";
          if (rpt >= 24) {
            rpt = rpt / 24;
            type = " ngày";
            if (rpt >= 365) {
              type = " năm";
              rpt = rpt / 365;
            }
          }
        }
      }

      return rpt.toFixed(2) + type;
    },
  }
};
</script>

<style scoped>

</style>